/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import { getDateFormat } from "@utils/datePickerUtils";
import { useNavigate } from "react-router-dom";
import { Anchor } from "hesus-ui-kit";
import {
  renderPriceWithCurrency,
  addSpace,
  getConvertedPrice,
} from "@utils/utils";
import {
  GenrealInfo,
  FlexRow,
  Title,
  GridRow,
  SectionContainer,
  OrderHeaderWrapper,
  GridSubItem,
} from "./OrderSummary.styled";
import "../../SupplierList.scss";

const OrderSummary = (props) => {
  const { t, orderData, quoteCurrency, site, exchangeRates } = props;
  const history = useNavigate();

  const backToClientOrderList = () => {
    history(`/planning/orders`);
  };

  return (
    <GenrealInfo>
      <FlexRow column="1fr">
        <Title bottom="1.5rem">
          {t("CLIENT_ORDER_SUMMARY") +
            " - " +
            getDateFormat(
              orderData?.clientOrder?.planningDate,
              "YYYY-MM-DD"
            )}
        </Title>
      </FlexRow>
      <GridRow column="1fr 1fr">
        <SectionContainer>
          <OrderHeaderWrapper>
            <FlexRow>
              <Title color="#fff" bottom="0px">
                <Anchor
                  url={`/site/view/${site?.id}/enquiry-view-${orderData?.sellingPrice?.enquiryId}`}
                  target="_blank"
                  className="supplier-list__enquiry-link "
                >
                  {t("ENQUIRY") + " #" + orderData?.sellingPrice?.enquiryId}
                </Anchor>{" "}
                {" - "}
                {orderData?.label}
              </Title>
            </FlexRow>
          </OrderHeaderWrapper>

          {orderData?.serviceItems?.map((item, itemIndex) => {
            return (
              <React.Fragment key={"service-item-" + item?.id + itemIndex}>
                {item?.hesusService?.needSupplierPlanning && (
                  <GridRow
                    column="1fr auto 25%"
                    gap="0rem"
                    borderRight="2px solid #767676"
                    borderLeft="2px solid #767676"
                    borderBottom="2px solid #767676"
                    borderRadius={
                      orderData?.serviceItems?.length === itemIndex + 1
                        ? "5px"
                        : "0px"
                    }
                  >
                    <GridRow gap="0rem">
                      <GridSubItem
                        fontWeight="700"
                        fontSize="16px"
                        padding="5px 5px 5px 10px"
                      >
                        {item.hesusService.name}
                      </GridSubItem>
                      <GridSubItem
                        fontWeight="400"
                        fontSize="16px"
                        color="#474747"
                        fontStyle="italic"
                        padding="5px 5px 5px 10px"
                      >
                        {item.hesusService.needProduct && item.product.name}
                        {item.hesusService.needProduct &&
                          item.hesusService.needTransport &&
                          " - "}
                        {item.hesusService.needTransport && item.transport.name}
                      </GridSubItem>
                    </GridRow>
                    <GridSubItem
                      fontWeight="700"
                      fontSize="16px"
                      textAlign="right"
                      color="#474747"
                    >
                      {renderPriceWithCurrency(
                        addSpace(
                          getConvertedPrice(
                            orderData?.currency?.id,
                            item?.sellingPrice,
                            exchangeRates
                          )
                        ),
                        t(item?.unit),
                        quoteCurrency?.symbol,
                        quoteCurrency?.position
                      )}
                    </GridSubItem>

                    <GridSubItem
                      fontWeight="700"
                      fontSize="16px"
                      textAlign="center"
                      borderLeft="2px solid #767676"
                    >
                      {item?.clientOrderItem?.quantity}{" "}
                      {t(item?.clientOrderItem?.unit)}
                    </GridSubItem>
                  </GridRow>
                )}
              </React.Fragment>
            );
          })}
        </SectionContainer>
        <SectionContainer>
          <GridRow column="auto 1fr" gap="0rem">
            <GridSubItem fontWeight="700" fontSize="16px" alignContent="left">
              {t("CLIENT_ORDER_SITE")} :
            </GridSubItem>
            <GridSubItem fontWeight="700" fontSize="16px">
              <Anchor
                url={`/site/view/${site?.id}/general-info`}
                target="_blank"
                className="supplier-list__site-link"
              >
                {" #" + site?.id + " - " + site?.name}
              </Anchor>
            </GridSubItem>
          </GridRow>
          <GridRow column="auto 1fr" gap="0rem">
            <GridSubItem fontWeight="700" fontSize="16px" alignContent="left">
              {t("CLIENT_ORDER_COMPANY")} :
            </GridSubItem>
            <GridSubItem fontSize="16px" color="#474747">
              {site?.company?.name}
            </GridSubItem>
          </GridRow>
          <GridRow column="1fr" gap="0rem">
            <GridSubItem fontWeight="700" fontSize="16px">
              {t("CLIENT_ORDER_ADDITIONAL_INFO")} :
            </GridSubItem>
          </GridRow>
          <GridRow
            column="1fr"
            gap="0rem"
            color="#474747"
            style={{
              maxHeight: orderData?.clientOrder?.comment ? "7rem" : "1.5rem",
              overflowY: "scroll",
            }}
          >
            <GridSubItem fontSize="16px" color="#474747">
              <div
                dangerouslySetInnerHTML={{
                  __html: orderData?.clientOrder?.comment,
                }}
              ></div>
            </GridSubItem>
          </GridRow>
        </SectionContainer>
      </GridRow>
    </GenrealInfo>
  );
};
OrderSummary.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(OrderSummary);
